"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SERVICE_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT = exports.SALES_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT = exports.FREE_SERVICE_PROFESSIONAL_ONBOARDING = exports.FREE_CRM_SALES_STARTER_KIT = void 0;

var _enviro = _interopRequireDefault(require("self-service-api/core/utilities/enviro"));

var isProd = _enviro.default.isProd();

var FREE_CRM_SALES_STARTER_KIT_PROD = 56;
var FREE_CRM_SALES_STARTER_KIT_QA = 119;
var FREE_SERVICE_PROFESSIONAL_ONBOARDING_PROD = 60;
var FREE_SERVICE_PROFESSIONAL_ONBOARDING_QA = 122;
var SALES_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT_PROD = 80;
var SALES_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT_QA = 145;
var SERVICE_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT_PROD = 81;
var SERVICE_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT_QA = 148;
var FREE_CRM_SALES_STARTER_KIT = isProd ? FREE_CRM_SALES_STARTER_KIT_PROD : FREE_CRM_SALES_STARTER_KIT_QA;
exports.FREE_CRM_SALES_STARTER_KIT = FREE_CRM_SALES_STARTER_KIT;
var FREE_SERVICE_PROFESSIONAL_ONBOARDING = isProd ? FREE_SERVICE_PROFESSIONAL_ONBOARDING_PROD : FREE_SERVICE_PROFESSIONAL_ONBOARDING_QA;
exports.FREE_SERVICE_PROFESSIONAL_ONBOARDING = FREE_SERVICE_PROFESSIONAL_ONBOARDING;
var SALES_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT = isProd ? SALES_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT_PROD : SALES_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT_QA;
exports.SALES_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT = SALES_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT;
var SERVICE_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT = isProd ? SERVICE_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT_PROD : SERVICE_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT_QA;
exports.SERVICE_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT = SERVICE_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/ProductBasedOfferIds.js
// module id = 209
// module chunks = 5 6 7